module.exports = "/images/cover-3.jpg";